import React from "react";
import Logo from "@/assets/svg/logo.svg?react";
import WorkspaceSwitcher from "../auth/WorkspaceSwitcher";

type Props = {};

const MobileHeader = (props: Props) => {
  return (
    <div className="py-1 px-6 w-full flex text-boudrawD justify-between items-center lg:hidden">
      <Logo width={52} />
      <WorkspaceSwitcher isExpanded={false} side="bottom" />
    </div>
  );
};

export default MobileHeader;
